import { PresaleHero } from "./components/PresaleHero";
import { PresaleStats } from "./components/PresaleStats";
import { PresalePurchase } from "./components/PresalePurchase";
import { Tokenomics } from "./components/Tokenomics";
import { Roadmap } from "./components/Roadmap";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { Zap, Twitter, MessageCircle } from "lucide-react";
import "./index.css";

export function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900/20 to-gray-900">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gray-900/80 backdrop-blur-md border-b border-purple-500/20">
        <div className="container mx-auto px-4 py-3 md:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 md:gap-3">
            <div className="bg-gradient-to-br from-purple-600 to-violet-600 p-1.5 md:p-2 rounded-lg transform transition-transform duration-300 hover:scale-110">
              <Zap className="w-5 h-5 md:w-6 md:h-6 text-white" fill="white" />
            </div>
            <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-purple-400 to-violet-400 bg-clip-text text-transparent">
              $PULSE
            </span>
          </div>
          <div className="flex items-center gap-2">
            <WalletMultiButton className="!bg-gradient-to-r !from-purple-600 !to-violet-600 hover:!from-purple-700 hover:!to-violet-700 !text-sm md:!text-base !px-3 md:!px-4 !py-2 md:!py-2.5" />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-16 md:pt-20">
        <PresaleHero />
        <PresaleStats />
        <PresalePurchase />
        <Tokenomics />
        <Roadmap />
      </main>

      {/* Footer */}
      <footer className="w-full py-12 md:py-16 px-4 border-t border-purple-500/20 mt-16 bg-gradient-to-b from-transparent to-gray-900/50">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-8">
            {/* Brand */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-4">
                <div className="bg-gradient-to-br from-purple-600 to-violet-600 p-2 rounded-lg">
                  <Zap className="w-6 h-6 text-white" fill="white" />
                </div>
                <span className="text-2xl font-bold text-white">$PULSE</span>
              </div>
              <p className="text-gray-400 text-sm md:text-base mb-4">
                Lightning-fast DeFi on Solana. Built for speed, designed for growth.
              </p>
              <div className="flex items-center justify-center md:justify-start gap-4">
                <a
                  href="https://x.com/PulseAppSOL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-purple-400 transition-colors"
                  aria-label="Twitter"
                >
                  <Twitter className="w-5 h-5" />
                </a>
                <a
                  href="https://discord.gg/NUUnxN8AdM"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-purple-400 transition-colors"
                  aria-label="Discord"
                >
                  <MessageCircle className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="text-center md:text-left">
              <h3 className="text-white font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#presale-purchase"
                    className="text-gray-400 hover:text-purple-400 transition-colors text-sm md:text-base"
                  >
                    Purchase Tokens
                  </a>
                </li>
                <li>
                  <a
                    href="#presale-stats"
                    className="text-gray-400 hover:text-purple-400 transition-colors text-sm md:text-base"
                  >
                    Presale Stats
                  </a>
                </li>
              </ul>
            </div>

          </div>

          {/* Bottom Bar */}
          <div className="border-t border-purple-500/20 pt-8 mt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-gray-500 text-xs md:text-sm text-center md:text-left">
                © 2025 $PULSE. All rights reserved.
              </p>
            </div>
            <p className="text-center text-xs text-gray-600 mt-4">
              This is not financial advice. Please do your own research before investing.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
